import { EditUserDTO } from './edit-user.dto'

export class EditUsersRequestDTO {
  constructor(public userDetailsChanges: EditUserDTO[]) {}
}
